
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Link } from 'react-router';
import * as d3 from 'd3';
import { simplePlaceName } from '../../utils/utils';
import styles from './RegionEAEData.css';
import withStyles from '../../decorators/withStyles';


class RegionEAEData extends Component {

  static propTypes = {
    placeType: PropTypes.string.isRequired,
    placeID: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {data: [[], []]}
  }

  // getGraphValues(forecastData, forecastName, waterLevel, textMap) {
  //   var data = [];
  //   var p = forecastData.forecastData[forecastName];
  //   if (typeof p === "undefined") {
  //     return data;
  //   }
  //   var level;
  //   if (forecastName === "Multi-year" || forecastName === "Single-year") {
  //     level = p.levels.filter(level => level.water_level == waterLevel.level && level.water_unit === waterLevel.unit);
  //   } else {
  //     level = p.levels.filter(level => level.water_unit === waterLevel.unit);
  //   }
  //   if (level.length === 1) {
  //     level = level[0];
  //   } else {
  //     return level;
  //   }
  //
  //   for (let i=0; i < level.xVals.length; i++) {
  //     data.push({x: level.xVals[i], y: level.yVals[i],
  //       text: textMap(waterLevel.level, waterLevel.unit, level.xVals[i], level.yVals[i], waterLevel.unit)});
  //   }
  //
  //   return data;
  // }

  indexTotals(totals) {
    const totalIdx = {};
    totals.forEach(t => {
      totalIdx[t.exposure_id] = t.value;
    });

    return totalIdx;
  }

  async loadData() {
    var self = this;
    const { placeType, placeID }  = this.props;

    const urls = [
      '/api/region_eae/' + placeType + '/' + placeID,
      '/api/region_eae/' + placeType + '/' + placeID + '/totals',
    ];

    const data = await Promise.all(urls.map((url) => d3.json(url)));
    self.setState({data});
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(props) {
    if (props.placeID !== this.props.placeID || props.placeType !== this.props.placeType) {
      this.loadData();
    }
  }

  render() {
    return (
      <div className="RegionEAEData">
        <div>{React.Children.map(this.props.children,
          child => React.cloneElement(child, {
            data: this.state.data[0],
            totals: this.indexTotals(this.state.data[1]),
            ...this.props
          }))}
        </div>
      </div>
    );
  };
}

export default compose(
  withStyles(styles),
  connect((state) => state),
)(RegionEAEData);
